"use client";

import { useState } from "react";

export default function ReadMore({
  html,
  limit = 450,
}: {
  html: string;
  limit?: number;
}) {
  const [expanded, setExpanded] = useState(false);

  const plainText = html
    .replace(/<[^>]*>/g, "")
    .replace(/&#(\d+);/g, (_, c) => String.fromCharCode(parseInt(c, 10)))
    .replace(/&#x([0-9a-fA-F]+);/g, (_, h) => String.fromCharCode(parseInt(h, 16)))
    .replace(/&amp;/g, "&")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&quot;/g, '"')
    .replace(/&apos;/g, "'")
    .replace(/&nbsp;/g, "\u00a0");
  const isLong = plainText.length > limit;

  if (!isLong) {
    return (
      <div
        className="blog-text mb-30 theme__html"
        dangerouslySetInnerHTML={{ __html: html }}
      />
    );
  }

  const truncated = plainText.slice(0, limit).trimEnd() + "…";

  return (
    <div className="blog-text mb-30 theme__html">
      {expanded ? (
        <span dangerouslySetInnerHTML={{ __html: html }} />
      ) : (
        <span>{truncated}</span>
      )}
      <button
        onClick={() => setExpanded((v) => !v)}
        style={{
          background: "none",
          border: "none",
          padding: "0 0 2px 6px",
          cursor: "pointer",
          fontWeight: 600,
          color: "var(--theme-color, #e8604c)",
          fontSize: "15px",
          textDecoration: "underline",
          textDecorationThickness: "2px",
          textUnderlineOffset: "4px",
          textDecorationColor: "currentColor",
        }}
      >
        {expanded ? "Show Less" : "Show More"}
      </button>
    </div>
  );
}
